import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
//import { DowngradeInjectable } from '@angular/upgrade/static';
//declare var angular: angular.IAngularStatic;
import { Observable } from 'rxjs';
import { UiService } from './core.ui.service';
import { UserService } from './core.user.service';

@Injectable()
export class MonitorService {

    constructor(private http: HttpClient, private uiService: UiService, private userService: UserService) {
    }

    public toggleMonitoring(section: string, ref_id: number, user_id: number, action, successOnMsg: string = '', 
            successOffMsg: string = '', failureOnMsg: string = '', failureOffMsg: string = '') {
        var url;
        if (action == 'on') {
            url = '/api/monitor';
        } else {
            url = `/api/monitor/${section}/${ref_id}/${user_id}`;
        }

        var successOn = successOnMsg || "You are now monitoring object " + section + " #" + ref_id,
            failureOn = failureOnMsg || "Monitoring of object " + section + " #" + ref_id + " failed",
            successOff = successOffMsg || "You are no longer monitoring object " + section + " #" + ref_id,
            failureOff = failureOffMsg || "Disabling monitoring of object " + section + " #" + ref_id + " failed",
            successText = (action == 'on') ? successOn : successOff,
            failureText = (action == 'on') ? failureOn : failureOff,
            restAction = (action == 'on') ? 'put' : 'delete';

        var params = {
            section: section,
            refId: ref_id,
            user: user_id
        };

        return new Promise((resolve, reject) => {
            let httpPromise: Promise<any>;
            if (restAction === 'put') {
                httpPromise = this.http.put(url, params, { responseType: 'text' }).toPromise();
            } else {
                httpPromise = this.http.delete(url, { responseType: 'text' }).toPromise();
            }

            httpPromise
                .then((ret) => {
                    this.uiService.message.showSuccess(successText);
                    resolve(ret);
                })
                .catch((err) => {
                    this.uiService.message.showError(failureText);
                    reject(err);
                });
        });
    }

    public set(section, ref_id, successOnMsg?, successOffMsg?, failureOnMsg?, failureOffMsg?) {
        var user_id = this.userService.session.getUserId();
        return this.toggleMonitoring(section, ref_id, user_id, 'on', successOnMsg, successOffMsg, failureOnMsg, failureOffMsg);
    }

    public unset(section, ref_id, successOnMsg?, successOffMsg?, failureOnMsg?, failureOffMsg?) {
        var user_id = this.userService.session.getUserId();
        return this.toggleMonitoring(section, ref_id, user_id, 'off', successOnMsg, successOffMsg, failureOnMsg, failureOffMsg);
    }

    public get(section, ref_id) {
        var user_id = this.userService.session.getUserId();
        return this.http.get(`/api/monitor?section=${section}&refId=${ref_id}&user=${user_id}`)
        .toPromise();
    }
}
